// Normalise a user-supplied website into a safe, absolute web URL for an <a href>.
//
// Only http(s) URLs are passed through untouched; anything else — a bare domain
// ("example.com") OR a dangerous scheme ("javascript://…", "data://…", "vbscript://…") — gets
// "https://" prepended. This guarantees the result ALWAYS starts with http(s)://, so a dangerous
// scheme becomes the (inert) path of an https URL rather than an executable href. Restricting to an
// http(s) allowlist is deliberate: a "does it contain '://'" check lets "javascript://%0aalert(1)"
// through, which React renders verbatim into href and executes on click (stored XSS, IGNITE-583 review).
export const normalizeExternalUrl = (raw: string): string => {
	const trimmed = raw.trim();
	return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
};
